//import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { initFirebaseBackend } from '@/authUtils';
import {getStorage} from "firebase/storage";
import {getFunctions} from "firebase/functions";

const firebaseConfig = {
     apiKey: process.env.VUE_APP_APIKEY,
     authDomain: process.env.VUE_APP_AUTHDOMAIN,
     projectId: process.env.VUE_APP_PROJECTId,
     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
     messagingSenderId: process.env.VUE_APP_MEASUREMENTID,
    appId: process.env.VUE_APP_APPId,
    measurementId: process.env.VUE_APP_MEASUREMENTID
};


const firebaseApp = initFirebaseBackend(firebaseConfig);


// Initialize Firebase

const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp);

export { db, firebaseApp, storage, functions };